import React from 'react'

import * as styles from './header.module.scss'

import DesktopNav from '../DesktopNav'
import MobileNav from '../MobileNav/MobileNav'

export default function Header({ theme = 'light', mobileTheme = 'dark' }) {
  return (
    <header className={styles.header}>
      <DesktopNav theme={theme} />
      <MobileNav mobileTheme={mobileTheme} />
    </header>
  )
}
